import PersonPinOutlinedIcon from '@mui/icons-material/PersonPinOutlined';
import Button from '@/trio-ui/Button';
import Modal, { ModalTypes } from '@/trio-ui/Modal';
import { StaffMember } from '@/types/api/staffMember';

export type Props = Pick<ModalTypes, 'isOpen' | 'onClose'> & {
  name: string;
  onConfirm?: () => void;
  isLoading?: boolean;
  createdStaffMember?: StaffMember;
  onCopyProfileUrl?: () => void;
  profileUrl: string;
  hasStaffMemberPagePermission?: boolean;
  message: string;
};

const CreateStaffMemberProfileModal = ({
  name,
  onConfirm,
  isLoading = false,
  isOpen,
  onClose,
  createdStaffMember,
  onCopyProfileUrl,
  profileUrl,
  hasStaffMemberPagePermission,
  message,
}: Props): JSX.Element => {
  const modalBody = <p>{message}</p>;

  const modalConfirmationBody = (
    <>
      <p>
        {`Great! ${name}’s Staff Member profile was successfully created!`}
        <br />
        <br />
        If you have access to People Suite, you can visit the new profile by clicking the button
        below. Otherwise you can copy the new profile link to share it.
      </p>
      <div className="tw-mt-6 tw-flex tw-justify-center tw-gap-4">
        {hasStaffMemberPagePermission && <Button href={profileUrl}>Visit profile</Button>}
        <Button variantStyle="outline" onClick={onCopyProfileUrl}>
          Copy profile link
        </Button>
        <Button variantStyle="outline" onClick={onClose}>
          Close
        </Button>
      </div>
    </>
  );

  const title = 'Create Staff Member Profile';

  return (
    <>
      <Modal
        modalTitle={title}
        headerIcon={PersonPinOutlinedIcon}
        bodyRender={modalBody}
        onConfirmLabel="Yes, create it"
        onCancelLabel="No"
        onConfirmClick={onConfirm}
        isCentered
        isButtonDisabled={isLoading}
        isOpen={Boolean(isOpen && !createdStaffMember)}
        onClose={onClose}
      />
      <Modal
        modalTitle={title}
        headerIcon={PersonPinOutlinedIcon}
        bodyRender={modalConfirmationBody}
        isCentered
        isOpen={Boolean(isOpen && createdStaffMember)}
        onClose={onClose}
        hideCancelButton
      />
    </>
  );
};

export default CreateStaffMemberProfileModal;
